import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

import { useAuth } from 'providers/AuthProvider'



const SkillsTracker = () => {

    const { t } = useTranslation();
    const auth = useAuth();
    const [loading, setLoading] = useState(false);

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Analytics.page_title'),
            url: '/analytics'
        },
        {
            label: t('SkillsTracker.page_title'),
            active: true
        }
    ];

    const [skills, setSkills] = useState([
        {
            category: "Skills",
            metrics: [
                { name: "Proficiency Level", description: "1-5 scale rating of overall skill mastery", value: 3 },
                { name: "Practice Hours", description: "Hours spent practicing this week", value: 8 },
                { name: "Projects Completed", description: "Number of projects utilizing this skill", value: 2 }
            ]
        },
        {
            category: "Learning Progress",
            metrics: [
                { name: "Resources Completed", description: "Courses/tutorials finished", value: 5 },
                { name: "Knowledge Retention", description: "Self-assessed understanding (1-5)", value: 4 },
                { name: "Learning Streak", description: "Consecutive days of learning", value: 12 }
            ]
        },
        {
            category: "Application & Impact",
            metrics: [
                { name: "Real-world Applications", description: "Times skill was used in practice", value: 7 },
                { name: "Problem-solving Success", description: "Successfully solved challenges", value: 6 },
                { name: "Peer Recognition", description: "Feedback/recognition received", value: 3 }
            ]
        }
    ]);

    // Sample progress data for the chart
    const progressData = [
        { month: 'Jan', proficiency: 2, practice: 5, projects: 1 },
        { month: 'Feb', proficiency: 3, practice: 7, projects: 2 },
        { month: 'Mar', proficiency: 3.5, practice: 8, projects: 2 },
        { month: 'Apr', proficiency: 4, practice: 10, projects: 3 }
    ];

    useEffect(() => {

    }, []);



    if (loading) {
        return <div>Loading...</div>;
    }



    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />

            <div className="mt-3">
                <Card className="w-100">
                    <Card.Header>
                        <Card.Title>Skills Progress Dashboard</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div className="mt-3">
                            {/* Progress Chart */}
                            <div className="h-50">
                                <LineChart width={600} height={250} data={progressData}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="month" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Line type="monotone" dataKey="proficiency" stroke="#8884d8" name="Proficiency" />
                                    <Line type="monotone" dataKey="practice" stroke="#82ca9d" name="Practice Hours" />
                                    <Line type="monotone" dataKey="projects" stroke="#ffc658" name="Projects" />
                                </LineChart>
                            </div>

                            {/* Metrics Cards */}
                            {skills.map((category, idx) => (
                                <Card key={idx} className="mb-4">
                                    <Card.Header>
                                        <Card.Title className="text-lg">{category.category}</Card.Title>
                                    </Card.Header>
                                    <Card.Body>
                                        <div className="row g-4">
                                            {category.metrics.map((metric, midx) => (
                                                <div key={midx} className="col-md-4">
                                                    <div className="p-4 border rounded">
                                                        <h3 className="fw-medium">{metric.name}</h3>
                                                        <p className="text-muted small">{metric.description}</p>
                                                        <p className="fs-4 fw-bold mt-2">{metric.value}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
};

export default SkillsTracker;